import { callApi } from "./api.service";

// Define the function to Follow fig data (Token required)
export const Follow = async (
    user_id: string,
    getToken: () => Promise<string | null>
) => {
    const endpoint = `/api/following/follow?following_id=${user_id}`;
    return await callApi(endpoint, 'POST', true, getToken);
}

// Define the function to Unfollow fig data (Token required)
export const Unfollow = async (
    user_id: string,
    getToken: () => Promise<string | null>,
) => {
    const endpoint = `/api/following/unfollow?following_id=${user_id}`;
    return await callApi(endpoint, 'DELETE', true, getToken);
}

export const GetFollowings = async (
    getToken: () => Promise<string | null>
) => {
    const endpoint = `/api/following/GetFollowings`;
    return await callApi(endpoint, 'GET', true, getToken);
}